module.exports = __webpack_public_path__ + "img/JK.a9a5f4a9.png";